export enum Authorization {
    PREMIUM = "PREMIUM",
    DELEGATION = "DELEGATION"
}
